<template>
  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer"
        >Configuraciones</a
      >
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3">Usuarios</span>
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <Toast />
    <div
      class="flex align-items-start flex-column lg:justify-content-between lg:flex-row"
    >
      <div>
        <div class="font-medium text-3xl text-900">
          Administrar Usuarios
          <Badge size="xlarge" severity="success"> {{ totalRegistros }}</Badge>
        </div>
      </div>
      <div class="mt-3 lg:mt-0">
        <Button
          v-if="'Usuario Crear' in auth.user.permissions"
          label="NUEVO USUARIO"
          class="p-button-outlined mr-2"
          icon="pi pi-plus"
          v-tooltip.top="'Nuevo Usuario'"
          @click="openNuevo"
        ></Button>
      </div>
    </div>
    <div class="mt-4">
      <DataTable
        ref="dtusers"
        :value="users"
        :loading="cargando"
        dataKey="id"
        :paginator="true"
        :rows="10"
        :filters="buscar"
        class="p-datatable-sm"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} Useres"
        responsiveLayout="scroll"
        showGridlines
        selectionMode="single"
        @row-dblclick="editUser($event.data)"
      >
        <template #header>
          <div
            class="flex flex-column md:flex-row md:justify-content-end md:align-items-end"
          >
            <span class="block mt-2 md:mt-0 p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="buscar['global'].value"
                placeholder="Buscar..."
              />
            </span>
          </div>
        </template>

        <template #loading>
          Se estan buscando los Usuarios, por favor espere!
        </template>

        <template #empty> No existen Usuarios! </template>

        <Column field="id" header="CÓDIGO" :sortable="true">
          {{ data.id }}
        </Column>
        <Column field="name" header="NOMBRE">
          {{ data.name }}
        </Column>
        <Column field="email" header="CORREO ELECTRÓNICO">
          {{ data.email }}
        </Column>
        <Column field="roles" header="ROLES DE USUARIO">
          <template #body="{ data }">
            <span
              class="product-badge bg-blue-400 mr-1 text-white"
              v-for="(rol, index) in data.roles"
              :key="index"
            >
              {{ rol }}
            </span>
          </template>
        </Column>
        <Column field="trabajador.nombre_completo" header="TRABAJADOR"></Column>
        <Column field="created_at" header="FECHA DE CREACIÓN">
          <template #body="{ data }">
            {{ formatDate(data.created_at) }}
          </template>
        </Column>
        <Column field="updated_at" header="ÚLTIMA MODIFICACIÓN">
          <template #body="{ data }">
            {{ formatDate(data.updated_at) }}
          </template>
        </Column>
        <Column headerStyle="min-width:10rem;" header="ACCIONES">
          <template #body="slotProps">
            <Button
              class="p-button-icon-only p-button-raised"
              icon="pi pi-ellipsis-v"
              v-tooltip.top="'Ver Acciones'"
              @click="$refs['menu' + slotProps.data.id].toggle($event)"
            />
            <Menu
              :ref="'menu' + slotProps.data.id"
              :popup="true"
              :model="acciones(slotProps.data)"
            >
            </Menu>
          </template>
        </Column>
      </DataTable>
    </div>

    <Dialog
      v-model:visible="userDialog"
      :style="{ width: '550px' }"
      header="Detalle de Usuario"
      :modal="true"
      class="p-fluid"
    >
      <div class="mt-2">
        <!-- Campos ocultos para engañar al autocompletado de Chrome -->
        <input type="email" name="fake_email" style="opacity: 0; position: absolute; z-index: -1; left: -9999px;" aria-hidden="true" autocomplete="username" tabindex="-1" />
        <input type="password" name="fake_password" style="opacity: 0; position: absolute; z-index: -1; left: -9999px;" aria-hidden="true" autocomplete="current-password" tabindex="-1" />

        <!-- SECCIÓN: Información Personal -->
        <fieldset class="border-1 border-300 border-round p-3 mb-4 w-full" style="border-style: solid;">
          <legend class="text-600 font-medium px-2">Información Personal</legend>
          
          <div class="formgrid grid mt-2">
            <div class="field col-12 md:col-12">
              <label for="name" class="font-medium text-900"
                >Nombre Completo <span class="text-red-500">*</span></label
              >
              <InputText 
                id="name"
                v-model.trim="user.name" 
                required="true" 
                autofocus 
                :class="{'p-invalid': errors.name}"
                placeholder="Ej. Juan Pérez"
              />
              <span class="p-error block mt-1 text-sm" v-if="errors.name">{{ errors.name[0] }}</span>
            </div>

            <div class="field col-12 md:col-12">
               <SelectTrabajador 
                  v-model="user.trabajador_id" 
                  label="Trabajador Asignado"
                  @update:modelValue="onTrabajadorSeleccionado"
                />
                <span class="p-error block mt-1 text-sm" v-if="errors.trabajador_id">{{ errors.trabajador_id[0] }}</span>
            </div>
          </div>
        </fieldset>

        <!-- SECCIÓN: Acceso y Roles -->
        <fieldset class="border-1 border-300 border-round p-3 mb-3 w-full" style="border-style: solid;">
          <legend class="text-600 font-medium px-2">Acceso y Roles</legend>
          
          <div class="formgrid grid mt-2">
            <div class="field col-12 md:col-7">
              <label for="email" class="font-medium text-900"
                >Correo Electrónico <span class="text-red-500">*</span></label
              >
              <InputText 
                id="email" 
                v-model="user.email" 
                required="true" 
                :class="{'p-invalid': errors.email}"
                placeholder="correo@empresa.com"
                autocomplete="off"
              />
              <span class="p-error block mt-1 text-sm" v-if="errors.email">{{ errors.email[0] }}</span>
            </div>

            <div class="field col-12 md:col-5">
              <label for="password" class="font-medium text-900"
                >Contraseña <span v-if="!user.id" class="text-red-500">*</span></label
              >
              <Password 
                id="password" 
                v-model="user.password" 
                :class="{'p-invalid': errors.password}"
                placeholder="••••••••"
                toggleMask
                :feedback="false"
                autocomplete="new-password"
              />
              <span class="p-error block mt-1 text-sm" v-if="errors.password">{{ errors.password[0] }}</span>
            </div>

            <div class="field col-12 md:col-12">
              <label for="roles" class="font-medium text-900"
                >Rol de Usuario <span class="text-red-500">*</span></label
              >
              <MultiSelect
                id="roles"
                v-model="user.roles"
                :options="roles"
                optionLabel="name"
                placeholder="Seleccione uno o más roles"
                display="chip"
                :class="{'p-invalid': errors.roles}"
              />
              <span class="p-error block mt-1 text-sm" v-if="errors.roles">Se necesita al menos un rol.</span>
            </div>

            <!-- SE MANTIENE EXACTAMENTE IGUAL EL CAMPO SUCURSAL -->
            <div class="field col-12 md:col-12">
              <strong>ADMINISTRAR SUCURSAL:</strong>
              <div class="p-inputgroup">
                <AutoComplete
                  field="nombre"
                  v-model="sucursalSelected"
                  :suggestions="sucursales"
                  placeholder="Buscar Sucursal"
                  v-tooltip.top="'Buscar Sucursal'"
                  @keyup.enter="buscarSucursal()"
                >
                  <template #item="slotProps">
                    <div>
                      <strong>{{ slotProps.item.nombre }}</strong>
                    </div>
                  </template>
                </AutoComplete>
                <Button
                  icon="pi pi-search"
                  class="p-button-warning"
                  v-tooltip.top="'Buscar Sucursal'"
                  @click="buscarSucursal()"
                />
              </div>
            </div>
          </div>
        </fieldset>
      </div>

      <!-- FOOTER ACTUALIZADO -->
      <template #footer>
        <div class="flex justify-content-end gap-2 w-full mt-3">
          <Button
            label="Cancelar"
            icon="pi pi-times"
            class="p-button-text p-button-secondary"
            @click="ocultarDialog"
            :disabled="enviado"
          />
          <Button
            :label="user.id ? 'Actualizar Usuario' : 'Guardar Usuario'"
            :icon="user.id ? 'pi pi-check' : 'pi pi-save'"
            class="p-button-primary"
            @click="guardarUser"
            :disabled="enviado"
            :loading="enviado"
          />
        </div>
      </template>
    </Dialog>

    <Dialog
      v-model:visible="deleteUserDialog"
      :style="{ width: '450px' }"
      header="Confirmar"
      :modal="true"
    >
      <div class="flex align-items-center justify-content-center">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span v-if="user"
          >Estas Seguro que quieres eliminar Usuario
          <b>{{ user.name }}</b> ?</span
        >
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          class="p-button-secondary"
          @click="deleteUserDialog = false"
        />
        <Button
          label="Si"
          icon="pi pi-check"
          class="p-button-primary"
          @click="deleteUser"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import UserService from "@/service/UserService";
import RolService from "@/service/RolService";
import { useAuth } from "@/stores";
import SelectTrabajador from "@/components/shared/SelectTrabajador.vue";
import * as yup from "yup";
export default {
  components: {
    SelectTrabajador
  },
  data() {
    return {
      users: null,
      cargando: true,
      userDialog: false,
      deleteUserDialog: false,
      user: {},
      buscar: {},
      enviado: false,
      roles: {},
      errors: {},
      totalRegistros: 0,
      sucursalSelected: 0,
      sucursales: [],
    };
  },
  userService: null,
  rolService: null,
  auth: null,
  created() {
    this.auth = useAuth();
    this.userService = new UserService();
    this.rolService = new RolService();
    this.initBuscar();
  },
  mounted() {
    this.cargarUsuarios();

    this.rolService.getRolesAll().then((roles) => {
      this.roles = roles;
    });
  },
  methods: {
    buscarSucursal() {
      let datos = {
        texto: this.sucursalSelected ? this.sucursalSelected : null,
      };
      this.userService.buscar_sucursal_user(datos).then((response) => {
        if (response.status == 400 || response.sucursales.length == 0) {
          this.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "No se encontró el cliente",
            life: 3000,
          });
          return;
        }
        this.sucursales = [...response.sucursales];
      });
    },
    onTrabajadorSeleccionado(trabajador) {
      if (trabajador && trabajador.nombre_completo) {
        // Asignamos el nombre solo si el campo actual está vacío
        if (!this.user.name || this.user.name.trim() === '') {
          this.user.name = trabajador.nombre_completo;
        }
      }
    },
    cargarUsuarios() {
      this.userService.getUsersAll().then((data) => {
        this.users = data;
        this.cargando = false;
        this.users.forEach((user) => {
          let rolesName = new Array();
          user.roles.forEach((rol) => {
            rolesName.push(rol.name.toLowerCase());
          });
          user.roles = rolesName;
          user.created_at = new Date(user.created_at);
          user.updated_at = new Date(user.updated_at);
        });
      });
    },
    acciones(datos) {
      let permisosUsuarioAuth = this.auth.user.permissions;
      return [
        {
          label: "Editar",
          disabled: "Usuario Editar" in permisosUsuarioAuth ? false : true,
          icon: "pi pi-pencil",
          command: () => {
            this.editUser(datos);
          },
        },
        {
          label: "Eliminar",
          disabled: "Usuario Eliminar" in permisosUsuarioAuth ? false : true,
          icon: "pi pi-trash",
          command: () => {
            this.confirmDeleteUser(datos);
          },
        },
      ];
    },
    openNuevo() {
      this.user = {};
      this.enviado = false;
      this.userDialog = true;
    },
    ocultarDialog() {
      this.errors = {};
      this.userDialog = false;
      this.enviado = false;
      this.user = {};
      this.sucursalSelected = 0;
      this.sucursales = [];
    },
    async guardarUser() {
      this.errors = {};
      this.enviado = true;

      //definir el esquema de validacion con YUP
      let schemaShape = {
        name: yup.string().required('El nombre es obligatorio').min(4, 'Mínimo 4 caracteres'),
        email: yup.string().required('El correo electrónico es obligatorio').email('Debe ser un correo electrónico válido'),
        roles: yup.array().min(1, 'Debe seleccionar al menos un rol').required('Se necesita rol')
      };
      //si es un usuairo nuevo, o si es edicion pero escribio una constraseña, aplicamos la regla estricta
      if(!this.user.id || (this.user.id && this.user.password)){
        schemaShape.password = yup.string()
        .required('La contraseña es obligatoria')
        .min(8, 'Debe tener al menos 8 caracteres')
        .matches(/[A-Z]/, 'Debe contener al menos una mayúscula')
        .matches(/[a-z]/, 'Debe contener al menos una minúscula')
        .matches(/[0-9]/, 'Debe contener al menos un número')
        .matches(/[\W_]/, 'Debe contener al menos un carácter especial');
      }
      const schema = yup.object().shape(schemaShape);

      try{
        // 3. EJECUTAR LA VALIDACIÓN DEL FRONTEND
        await schema.validate(this.user, { abortEarly: false });        
        //return
      }catch(err){
        // 4. MAPEAR LOS ERRORES DE YUP AL FORMATO DE LARAVEL QUE YA USA TU TEMPLATE
        let frontendErrors = {};
        err.inner.forEach(error => {
          if (!frontendErrors[error.path]) {
            frontendErrors[error.path] = [error.message];
          }
        });
        // Asignamos los errores al objeto que lee tu template
        this.errors = frontendErrors;
        this.enviado = false;
        
        // Mostramos un toast de advertencia
        this.$toast.add({
          severity: "warn",
          summary: "Faltan datos",
          detail: "Por favor, corrige los errores en el formulario.",
          life: 3000,
        });
        
        return; // Detenemos la ejecución para que NO envíe al backend
      }
      if (this.user.id) {
        //editar Usuario

        let user_enviar = {
          ...this.user,
          sucursal_id: this.sucursalSelected ? this.sucursalSelected.id : 0,
          trabajador_id: (this.user.trabajador_id && typeof this.user.trabajador_id === 'object') ? this.user.trabajador_id.id : this.user.trabajador_id,
        };

        this.userService.updatedUser(user_enviar).then((data) => {
          if (Object.prototype.hasOwnProperty.call(data, "errors")) {
            this.errors = data.errors;
          } else {
            this.errors = {};

            this.$toast.add({
              severity: "success",
              summary: "Exito!",
              detail: "Usuario Actualizado",
              life: 3000,
            });
            this.cargarUsuarios();
            this.ocultarModalUser();
          }
          this.enviado = false;
        });
      } else {
        //Creando Nuevo Usuario

        let user_enviar = {
          ...this.user,
          sucursal_id: this.sucursalSelected ? this.sucursalSelected.id : null,
          trabajador_id: (this.user.trabajador_id && typeof this.user.trabajador_id === 'object') ? this.user.trabajador_id.id : this.user.trabajador_id,
        };
        this.userService.sendUserNuevo(user_enviar).then((user) => {
          if (Object.prototype.hasOwnProperty.call(user, "errors")) {
            this.errors = user.errors;
          } else {
            this.errors = {};
            this.$toast.add({
              severity: "success",
              summary: "Exito!",
              detail: "Usuario Creado",
              life: 10000,
            });
            this.cargarUsuarios();
            this.ocultarModalUser();
          }
          this.enviado = false;
        });
      }
    },
    ocultarModalUser() {
      this.userDialog = false;
      this.user = {};
      this.sucursalSelected = 0;
      this.sucursales = [];
    },
    editUser(user) {
      this.user = { ...user };
      this.user.roles = this.roles.filter((rol) => {
        return user.roles.includes(rol.name.toLowerCase());
      });
      this.sucursalSelected = user.sucursal_id
        ? { id: user.sucursal_id, nombre: user.sucursal.nombre }
        : null;
      this.user.trabajador_id = user.trabajador 
        ? { id: user.trabajador.id, nombre_completo: user.trabajador.nombre_completo }
        : null;
      this.userDialog = true;
    },
    confirmDeleteUser(user) {
      this.user = { ...user };
      this.deleteUserDialog = true;
    },
    deleteUser() {
      this.userService.deleteUser(this.user).then((data) => {
        if (data.status == 200) {
          this.$toast.add({
            severity: "success",
            summary: "Exito!",
            detail: data.mensaje,
            life: 3000,
          });
          this.cargarUsuarios();
          this.deleteUserDialog = false;
          this.user = {};
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Error!",
            detail: data.mensaje,
            life: 3000,
          });
          this.deleteUserDialog = false;
        }
      });
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.users.length; i++) {
        if (this.users[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    initBuscar() {
      this.buscar = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
    /* verDetalle(user){
				this.$router.push(`/user/${user.id}/detalle`); 
		}, */
    formatDate(value) {
      return value.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
      });
    },
  },
  watch: {
    users() {
      this.totalRegistros = this.users.length;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/demo/badges.scss";
.p-invalid {
  color: red;
}
</style>
